module.exports = __webpack_public_path__ + "playstore-icon.png?707c1bbb8db16e93a85c3b302c1bc077";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/playstore-icon.png
// module id = 310
// module chunks = 0